import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcVisa, faCcMastercard, faCcAmex } from '@fortawesome/free-brands-svg-icons';
import {
  Payment,
  TypePaymentStatus
} from 'app/viaje/viajeTraslado/viajeTraslado/models/TransferReservationPartial';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

interface PaymentCardProps {
  payment: Payment;
}

const PaymentCard: FC<PaymentCardProps> = ({ payment }) => {
  const {
    last_four_digits,
    expiration_month,
    expiration_year,
    issuer_name,
    payment_method
  } = payment;

  const getCardIcon = () => {
    if (
      issuer_name?.toLowerCase() === 'mastercard' ||
      payment_method?.toLowerCase() === 'master' ||
      payment_method?.toLowerCase() === 'debmaster'
    ) {
      return <FontAwesomeIcon icon={faCcMastercard} className="text-4xl" />;
    }
    if (
      issuer_name?.toLowerCase() === 'american express' ||
      issuer_name?.toLowerCase() === 'amex' ||
      payment_method?.toLowerCase() === 'amex' ||
      payment_method?.toLowerCase() === 'american' ||
      payment_method?.toLowerCase() === 'american express' ||
      payment_method?.toLowerCase() === 'americanexpress'
    ) {
      return <FontAwesomeIcon icon={faCcAmex} className="text-4xl" />;
    }
    if (
      issuer_name?.toLowerCase() === 'visa' ||
      payment_method?.toLowerCase() === 'visa' ||
      payment_method?.toLowerCase() === 'debvisa'
    ) {
      return <FontAwesomeIcon icon={faCcVisa} className="text-4xl" />;
    }
    return null;
  };

  const isCancelled = payment.states.some(
    (state) =>
      state.status_name === TypePaymentStatus.CANCELLED ||
      state.status_name === TypePaymentStatus.REJECTED
  );
  const isApproved = payment.states.some(
    (state) => state.status_name === TypePaymentStatus.APPROVED
  );

  return (
    <div
      className="w-80 h-48 rounded-2xl text-white p-4 relative shadow-lg"
      style={{
        background:
          'linear-gradient(135deg, #00080F 0%, #002F47 50%, #0270AB 100%)'
      }}
    >
      {/* Chip de la tarjeta */}
      <div className="w-10 h-8 bg-gray-300 rounded-md mb-4"></div>

      {/* Logo de la tarjeta */}
      <div className="absolute top-4 right-4 text-white">{getCardIcon()}</div>

      {/* Número de la tarjeta */}
      <div className="tracking-widest text-xl mb-2 font-mono">
        **** **** **** {last_four_digits}
      </div>

      {/* Información inferior */}
      <div className="flex justify-between items-center mt-8">
        <div className="text-sm uppercase font-medium">{issuer_name}</div>
        <div className="text-sm font-mono">
          {expiration_month}/{expiration_year.toString().slice(-2)}
        </div>
      </div>
      {isCancelled && !isApproved && (
        <div
          className="absolute flex  items-center justify-center"
          style={{
            top: '55%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '110%',
            height: '20%',
            backgroundColor: 'rgba(255, 0, 0, 0.7)',
            boxShadow: '0px 0px 8px rgba(156, 0, 0, 0.4)',
            pointerEvents: 'none'
          }}
          area-label="No pudimos procesar el pago"
        >
          <span
            className="text-center font-bold"
            style={{
              color: '#FFFFFF',
              textShadow: '0px 0px 45px rgba(156, 0, 0,)',
              letterSpacing: '1px'
            }}
          >
            RECHAZADA
          </span>
        </div>
      )}
      {isApproved && (
        <div
          className="absolute flex  items-center justify-center"
          style={{
            top: '55%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50px',
            height: '50px',
            borderRadius: '9999px',
            border: '1px solid rgba(0, 255, 0, 0.7)',
            boxShadow: '0px 0px 10px rgba(0, 255, 0, 0.8)',
            pointerEvents: 'none'
          }}
          area-label="No pudimos procesar el pago"
        >
          <div className="flex items-center justify-center "
          style={{
            backgroundColor: 'white',
            borderRadius: '9999px',
            width: '40px',
            height: '40px',
          }}>
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="text-4xl"
              style={{
                color: 'rgba(0, 255, 0, 1)',
                height: '45px',
                width: '45px',
                borderRadius: '9999px',
                
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentCard;
